import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Identifier, SearchHttpParams } from '@heda/core-util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DigiluguReferral, ReferralSearchParam } from 'app/integration/document/services/digilugu-referral';
import { PatientIdentifier } from 'app/mpi/lib/patient/services/patient';

@Injectable()
export class DigiluguReferralService {
  constructor(private http: HttpClient) {}

  protected baseUrl = `${environment.estnhsApi}/digilugu/referral`;

  public query(params: ReferralSearchParam): Observable<DigiluguReferral[]> {
    return this.http
      .get(`${this.baseUrl}`, { params: SearchHttpParams.build(params) })
      .pipe(map((resp) => resp as DigiluguReferral[]));
  }

  public load(identifier: Identifier, patientIdentifer: PatientIdentifier): Observable<DigiluguReferral> {
    const id = encodeURIComponent(identifier.system + '|' + identifier.value);
    const pid = this.toPatientIdentifier(patientIdentifer);
    const pCountry = patientIdentifer.country;
    let queryParams = `?identifier=${id}&patientIdentifier=${pid}`;
    if (pCountry?.length) {
      queryParams += `&patientCountry=${pCountry}`;
    }
    return this.http
      .get(`${this.baseUrl}/document` + queryParams)
      .pipe(map((resp) => resp as DigiluguReferral));
  }

  private toPatientIdentifier(patientIdentifer: PatientIdentifier): string {
    if (patientIdentifer.system === 'country') {
      return encodeURIComponent('urn:iso:3166:' + patientIdentifer.country + '|' + patientIdentifer.value);
    }
    return encodeURIComponent(patientIdentifer.system + '|' + patientIdentifer.value);
  }
}
